import { useFormContext, useWatch } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { GapBox } from 'components/Box'
import { BoxForm, NumberField, Switch } from 'components/Form'
import { SectionHeader } from 'components/Header'
import { TextLink } from 'components/Link'
import Paper from 'components/Paper'
import { useAbility } from 'providers/casl'
import { KNOWLEDGE_BASE_URL } from '../../constants'
import { Schema } from '../../schema'
import { MaxRttSoftValidator } from './MaxRttSoftValidator'

export const ConnectionSpeedSection = (): JSX.Element => {
  const { t } = useTranslation('features/globalSetup', {
    keyPrefix: 'defaults.prebid.connectionSpeed',
  })
  const { t: tc } = useTranslation('common')
  const { control } = useFormContext<Schema>()
  const {
    connectionSpeed: { disablePrebidStack },
  } = useWatch()

  const RttSoftValidator = MaxRttSoftValidator<Schema>({ path: 'connectionSpeed.maxRtt' })

  const ability = useAbility()
  const cannotUpdate: boolean = ability.cannot('update', 'GlobalSetupFeature-defaults-prebidStack')

  return (
    <Paper>
      <SectionHeader
        subtitle={t('subtitle')}
        subtitleEndAdornment={
          <TextLink
            link={{
              title: tc('learnMore'),
              url: KNOWLEDGE_BASE_URL.CONNECTION_SPEED,
            }}
          />
        }
        title={t('title')}
      />

      <GapBox />

      <BoxForm>
        <Switch
          control={control}
          disabled={cannotUpdate}
          label={t('disablePrebidStack.label')}
          labelPlacement='start'
          name='connectionSpeed.disablePrebidStack'
        />

        {disablePrebidStack && (
          <NumberField
            control={control}
            disabled={cannotUpdate}
            helperText={RttSoftValidator}
            label={t('maxRtt.label')}
            name='connectionSpeed.maxRtt'
            tooltip={{ content: t('maxRtt.tooltip') }}
            width='md'
          />
        )}
      </BoxForm>
    </Paper>
  )
}
